export class BlueprintDetails {
}
export class Input {
}
export class Outputs {
}
export class Component {
}
